export default __webpack_public_path__ + "bb8a8a5e642881d410b3d0f8664002df.jpg";